export const constVal = {
  'INITIAL': 0,
  'FAILED': 1,
  'SUCCESS': 2,
  'INVALID_INDEX': -1,
  'MSG_TYPE_ERROR': 'Error',
  'MSG_TYPE_CONFIRMATION': 'Confirmation',
  'MSG_TYPE_INFORMATION': 'Info',
  'MSG_TYPE_WARNING': 'Warning',
  'MSG_TYPE_PROGRESS': 'Progress',
  'ENCHANCED_INSTALL': 1,
  'BASIC_INSTALL_START': 2,
  'BASIC_INSTALL_VERIFY': 3,
  'BASIC_INSTALL_VEIRY_COMPLETE': 4,
  'BASIC_INSTALL_COMPLETE': 5
};